const INITIAL_SCHEDULES = [
  { value: "7", label: "S", active: false },
  { value: "1", label: "M", active: false },
  { value: "2", label: "T", active: false },
  { value: "3", label: "W", active: false },
  { value: "4", label: "T", active: false },
  { value: "5", label: "F", active: false },
  { value: "6", label: "S", active: false },
];

export const convertStaffData = ({
  fetchLeaveDetail,
  fetchPerformanceReviews,
  allOffices,
  officeIdSelectedView,
  staffMemberId,
  allData,
}) => {
  const officevalue = allOffices.find((res) => res.id === officeIdSelectedView);
  if (!officevalue) return {};
  const value = officevalue.otherDetails;
  if (officevalue.staffId) {
    fetchLeaveDetail(null, officevalue.staffId);
    fetchPerformanceReviews(officevalue.id, officevalue.staffId);
    value.staffId = officevalue.staffId;
  } else {
    fetchLeaveDetail(null, officevalue.inviteId);
    value.inviteId = officevalue.inviteId;
  }

  let schedules = INITIAL_SCHEDULES;
  if (value?.schedule) {
    const scheduleDays = value?.schedule?.split(",") || [];
    schedules = INITIAL_SCHEDULES.map((item) => ({
      ...item,
      active: scheduleDays.includes(item.value),
    }));
  }

  // call from userOfficeList
  [
    "annualSalary",
    "commission",
    "commissionType",
    "bonus",
    "bonusType",
  ].forEach((key) => {
    if (!value[key]) {
      value[key] = key.includes("Type") ? "1" : "0";
    }
  });

  return {
    ...value,
    designation: value?.designation?.name,
    departmentName: value?.department?.name,
    departmentId: value?.department?.id || null,
    designationId: value?.designation?.id,
    reportToName:
      (value?.reportTo?.firstName || "") +
      (value?.reportTo?.lastName ? " " + value?.reportTo?.lastName : ""),
    reportToId: value?.reportTo?.id || null,
    staffMemberId,
    schedules,
    colourCode: allData?.colourCode || value.colourCode,
  };
};
